import React from 'react';

export default function FavoriteIcon({ active }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.13238 5.97743L5.39759 5.35455L7.43406 0.939035C7.65189 0.466745 8.32644 0.476371 8.5307 0.954683L10.4096 5.35455L14.8253 5.97716C15.3124 6.04584 15.5144 6.63923 15.1704 6.99086L11.9518 10.2811L12.7087 14.6139C12.7938 15.1015 12.2853 15.4767 11.8445 15.2514L7.90361 13.2371L3.96269 15.2514C3.52196 15.4767 3.01339 15.1015 3.09856 14.6139L3.85542 10.2811L0.780081 6.98013C0.450262 6.6261 0.653609 6.04735 1.13238 5.97743Z" fill={active ? '#ecd018' : '#A2A2A2'} />
    </svg>
  );
}
